// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__35wdE","content":"Footer_content__2lZHa route-container","copyright":"Footer_copyright__2wqDr"};